import Model from './model'

export default class VehicleMake extends Model {
    /**
     *
     * @returns {string}
     */
    resource() {
        return 'web-api/vehicle-make'
    }
}
